import { render } from "./MeusDados.vue?vue&type=template&id=0aa77501&scoped=true"
import script from "./MeusDados.vue?vue&type=script&lang=js"
export * from "./MeusDados.vue?vue&type=script&lang=js"

import "./MeusDados.vue?vue&type=style&index=0&id=0aa77501&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa77501"]])

export default __exports__